import React, { useContext } from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material//CardContent'
import {
  Box,
  CardActions, CardHeader,
  Divider, Grid,
  IconButton,
  Typography
} from '@mui/material'
import FavoriteIcon from '@mui/icons-material/Favorite'
import ShareIcon from '@mui/icons-material/Share'
import ChatIcon from '@mui/icons-material/Chat'
import { AuthTokenContext } from '../../contexts/AuthTokenContext'
import { Link, useNavigate } from 'react-router-dom'
import { CommunityAvatar } from '../../commonUIComponents/CustomAvatar'
import momentUtil from '../../../util/momentUtil'

const CompactPostCard = ({ post, fetchPosts }) => {
  const { authToken } = useContext(AuthTokenContext)
  const { id, communityId, nickname, title, body, link, images, createdDate, avatarImageUrl } = post
  const navigate = useNavigate()

  const onClickPostHandler = event => {
    event.preventDefault()
    navigate(`/view-post/${id}`)
  }

  const subheader = nickname || undefined
  const subheaderProps = nickname ? { fontSize: 12 } : undefined

  const PostImage = () => {
    return (
      <>
        {images
          ? (
            <Box
              key={images[0]}
              component="img"
              sx={{
                overflow: 'hidden',
                objectFit: 'contain',
                borderRadius: '8px',
                maxWidth: 102,
                maxHeight: 76
              }}
              alt="Post Image"
              src={images[0]}
            />
            )
          : undefined
        }
      </>
    )
  }

  return (
    <>
      {post
        ? (
          <Grid item xs={12}>
            <Grid
              container
              direction="row"
              justifyContent="flex-start"
              alignItems="center"
            >
              <Grid container alignItems="center">
                <Grid item xs="auto">
                  <PostImage />
                </Grid>
                <Grid item xs>
                  <Card
                    elevation={0}
                    sx={{
                      maxWidth: 900,
                      maxHeight: 700,
                      borderRadius: '16px',
                      ':hover': {
                        boxShadow: 6,
                        backgroundColor: '#181c20'
                      }
                    }}
                  >
                    <CardHeader
                      // onClick={onClickPostHeaderHandler}
                      avatar={
                        <CommunityAvatar src={avatarImageUrl} communityId={communityId} width={18} height={18} />
                      }
                      titleTypographyProps={{ variant: 'body2', fontSize: 12, fontWeight: 'bold', ml: '-0.5rem' }}
                      title={
                        <>
                          r/{communityId}
                          <Typography sx={{ display: 'inline', fontSize: 12 }}
                                      component="span"
                                      variant="body2"
                                      color="text.secondary">
                            {' - '}{momentUtil.createTimeDiffTag(createdDate)}
                          </Typography>
                        </>
                      }
                      subheaderTypographyProps={subheaderProps}
                      subheader={
                        subheader
                      }
                    />
                    <CardContent
                      onClick={onClickPostHandler}
                      sx={{
                        textDecoration: 'none',
                        p: 0,
                        '&:last-child': { p: 0 }
                      }}
                    >
                      <Typography variant="h6" color="common.white" component="p" sx={{ pl: '1rem', mt: '-0.5rem', fontSize: 12, fontWeight: 'bold' }}>
                        {title}
                      </Typography>
                    </CardContent>
                    <CardActions disableSpacing sx={{ mt: -1 }}>
                      <IconButton aria-label="comment" to={`/view-post/${id}`} component={Link} sx={{ textDecoration: 'none' }}>
                        <ChatIcon fontSize="small" />
                      </IconButton>
                      <IconButton aria-label="like">
                        <FavoriteIcon fontSize="small" />
                      </IconButton>
                      <IconButton aria-label="share">
                        <ShareIcon fontSize="small" />
                      </IconButton>
                    </CardActions>
                  </Card>
                </Grid>
              </Grid>
            </Grid>
            <Divider/>
          </Grid>
          )
        : undefined}
    </>
  )
}

export default CompactPostCard
